import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styles from './CardsSelect.scss'

const propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      subLabel: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  rowLength: PropTypes.oneOf([3, 4]),
  value: PropTypes.string.isRequired,
}

const defaultProps = {
  className: null,
  disabled: false,
  options: [],
  rowLength: 4,
}

function CardsSelect({
  className,
  disabled,
  options,
  value,
  rowLength,
  onChange,
}) {
  return (
    <div
      className={classnames(styles.base, className, {
        [styles.wide]: rowLength === 3,
        [styles.disabled]: disabled,
      })}
    >
      {options.map(x => (
        <div
          className={classnames(styles.cell, {
            [styles.selected]: value === x.value,
          })}
          key={x.value}
          onClick={() => onChange(x.value)}
        >
          <div className={styles.label}>{x.label}</div>
          <div className={styles.subLabel}>{x.subLabel}</div>
        </div>
      ))}
    </div>
  )
}

CardsSelect.propTypes = propTypes
CardsSelect.defaultProps = defaultProps

export default CardsSelect
